import { useCallback } from "react";
import { useRecoEngine } from "../context/RecoEngineContext";
import useRecoEngineSession from "./useRecoEngineSession";
import ChatBlock from "../components/ChatBlock";

const useQueryLocation = () => {
  const { setQueryObject, setRenderBlocks } = useRecoEngine();
  const { getSession, addBlock, updateSessionData } = useRecoEngineSession();

  const handleQueryLocation = useCallback(
    (query, queryObject, longitude, latitude, radius, fsa) => {
    if (!(query && !queryObject.query)) return;

    const newQueryObject = {
      ...queryObject,
      query,
      latitude,
      longitude,
      radius,
      fsa
    };

    setQueryObject(newQueryObject);
    updateSessionData({
      currentQuery: query,
      queryObject: newQueryObject
    });

    const session = getSession();
    if (!session || session.blocks.length <= 1) { // <= 1 because we have the starting message
      const userQueryBlock = {
        type: "chat" as const,
        data: {
          text: query,
          engineResponse: false
        }
      };
      addBlock(userQueryBlock);

      // Add to rendered blocks
      setRenderBlocks(prevBlocks => [
        ...prevBlocks,
        <ChatBlock
          key="user-query"
          text={query}
          engineResponse={false}
        />
      ]);
    }
  }, [setQueryObject, updateSessionData, getSession, addBlock, setRenderBlocks]);

  return { handleQueryLocation };
};

export default useQueryLocation;